import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _filter from 'lodash/filter';
import {
  getManagers,
  getManager,
  createManager,
  updateManager,
  deleteManager,
  clearLocalManagers,
  clearLocalActiveManager
} from './actions';

export const initialState = {
  all: { 
    data: [], 
    pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } 
  },
  manager: { 
    id: '', 
    email: '', 
    first_name: '', 
    last_name: '', 
    updated_at: '' 
  },
  loading: { 
    all: false, 
    manager: false 
  }
};

const  slice = createSlice({
  name: 'managers',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getManagers.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getManagers.fulfilled, (state, action) => {
        const { managers, pagination } = action.payload;
        
        state.loading.all = false;
        state.all.data = [...state.all.data, ...managers];
        state.all.pagination = pagination;
      })
      .addCase(getManagers.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getManager.pending, (state) => {
        state.loading.manager = true;
      })
      .addCase(getManager.fulfilled, (state, action) => {
        const { manager } = action.payload;
        const foundedManager = !!_find(state.all.data, (m) => m.id === manager.id);
        const updatedManager = { ...state.manager, ...manager };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedManager ? _map(state.all.data, (m) => m.id === manager.id ? { ...m, ...manager } : m) : [...[manager], ...oldAllData]; 
        const pagination = foundedManager ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.manager = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedManager) state.manager = updatedManager;       
      })
      .addCase(getManager.rejected, (state) => {
        state.loading.manager = false;
      })
      .addCase(createManager.pending, (state) => {
        state.loading.manager = true;
      })
      .addCase(createManager.fulfilled, (state, action) => {
        const { manager } = action.payload;
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = [...[manager], ...oldAllData];
        const pagination = { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.manager = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        state.manager = manager;
      })
      .addCase(createManager.rejected, (state) => {
        state.loading.manager = false;
      })
      .addCase(updateManager.pending, (state) => {
        state.loading.manager = true;
      })
      .addCase(updateManager.fulfilled, (state, action) => {
        const { status, manager } = action.payload;
        const data = _map(state.all.data, (m) => m.id === manager.id ? { ...m, ...manager } : m)
        const updatedManager = { ...state.manager, ...manager };
        
        state.loading.manager = false;
        if (status === 204) {
          state.all.data = data;
          state.manager = updatedManager;
        }     
      })
      .addCase(updateManager.rejected, (state) => {
        state.loading.manager = false;
      })
      .addCase(deleteManager.pending, (state) => {
        state.loading.manager = true;
      })
      .addCase(deleteManager.fulfilled, (state, action) => {
        const { status, id } = action.payload;
        
        state.loading.manager = false;
        if (status === 204) {
          state.all.data = _filter(state.all.data, (item) => item.id !== id);
          state.all.pagination = { ...state.all.pagination, count: state.all.pagination.count - 1, total_count: state.all.pagination.total_count - 1 };
          state.manager = initialState.manager;
        }
      })
      .addCase(deleteManager.rejected, (state) => {
        state.loading.manager = false;
      })
      .addCase(clearLocalManagers, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveManager, state => {
        state.manager = initialState.manager;
      })
  }
})

export default slice.reducer;